// Generated by Melange

import * as Buhta_cabinet__AdminIdentitiesSubHeader from "../../../components/molecules/AdminSidebar/AdminIdentitiesSubHeader.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__ErrorPage from "../../ErrorPage.js";
import * as Buhta_cabinet__Identity from "../../../models/Identity.js";
import * as Buhta_cabinet__Link from "../../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_components__LoadingDiv from "../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function IdentityApiPage(Props) {
  let openMenu = Props.openMenu;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  let identityId;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Admin */ 7) {
    identityId = "";
  } else {
    const match = currentRoute._0;
    if (/* tag */ typeof match === "number" || typeof match === "string" || match.TAG !== /* Identities */ 2) {
      identityId = "";
    } else {
      const match$1 = match._0;
      if (/* tag */ typeof match$1 === "number" || typeof match$1 === "string") {
        identityId = "";
      } else {
        switch (match$1._1) {
          case /* General */ 0 :
          case /* Security */ 1 :
            identityId = "";
            break;
          case /* API */ 2 :
            identityId = match$1._0;
            break;
        }
      }
    }
  }
  const match$2 = Buhta_cabinet__Identity.use(undefined);
  const identity = match$2[0];
  React.useEffect((function () {
    
  }), [identity]);
  const subheader = JsxRuntime.jsx(Buhta_cabinet__AdminIdentitiesSubHeader.make, {
    currentRoute: currentRoute,
    identityId: identityId
  });
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
    title: "Ключи API"
  });
  let tmp;
  if (typeof identity === "string") {
    tmp = JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {});
  } else if (identity.NAME === "Data") {
    const profile = identity.VAL.profile;
    const profile$1 = profile !== undefined ? profile : ({
        id: 0,
        email: "",
        phone: "",
        first_name: "",
        last_name: "",
        userpic_url: "",
        tenants: /* [] */ 0,
        create_time: undefined
      });
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("img", {
          className: "w-5 h-5",
          src: StaticAsset.src("/static/icons/back-arrow.svg")
        }),
        JsxRuntime.jsx(Buhta_components__Text.H4.make, {
          className: "ml-4 text-white",
          children: profile$1.first_name + (" " + profile$1.last_name)
        })
      ],
      className: "flex items-center"
    });
  } else {
    console.log(identity.VAL);
    tmp = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
  }
  const headerMobile = JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
              route: {
                TAG: /* Admin */ 7,
                _0: {
                  TAG: /* Identities */ 2,
                  _0: /* List */ 0
                }
              },
              className: " flex justify-between",
              children: tmp
            }),
            className: "flex items-center gap-2"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "border-l border-asphalt-dark h-5"
              }),
              JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx("img", {
                  className: "w-6 h-6",
                  src: StaticAsset.src("/static/icons/menu-white-24.svg")
                }),
                onClick: openMenu
              })
            ],
            className: "flex items-center gap-2"
          })
        ],
        className: "h-14 bg-black flex justify-between px-4"
      }),
      subheader
    ],
    className: "flex flex-col"
  });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: deviceType === "mobile" ? headerMobile : header,
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                children: "Personal"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "w-3 h-3 rounded-full bg-success"
                  }),
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    className: "text-gray-medium",
                    children: "Активный"
                  })
                ],
                className: "flex gap-2 items-center"
              })
            ],
            className: "hover:bg-gray-pale px-10 py-3"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                    children: "zxz"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        className: "w-3 h-3 rounded-full bg-alert"
                      }),
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-gray-medium",
                        children: "Заблокирован"
                      })
                    ],
                    className: "flex gap-2 items-center"
                  })
                ]
              }),
              JsxRuntime.jsx("img", {
                className: "w-5 h-5",
                src: StaticAsset.src("/static/icons/delete-red-20.svg")
              })
            ],
            className: "hover:bg-gray-pale px-10 py-3 flex justify-between items-center"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                children: "legacy-test"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "w-3 h-3 rounded-full bg-success"
                  }),
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    className: "text-gray-medium",
                    children: "Активный"
                  })
                ],
                className: "flex gap-2 items-center"
              })
            ],
            className: "hover:bg-gray-pale px-10 py-3"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                children: "test"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "w-3 h-3 rounded-full bg-gray-medium"
                  }),
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    className: "text-gray-medium",
                    children: "Истек"
                  })
                ],
                className: "flex gap-2 items-center"
              })
            ],
            className: "hover:bg-gray-pale px-10 py-3"
          }),
          JsxRuntime.jsx("hr", {
            className: "mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-6 h-6",
                src: StaticAsset.src("/static/icons/plus-24.svg")
              }),
              JsxRuntime.jsx(Buhta_components__Text.P.make, {
                children: "Добавить ключ"
              })
            ],
            className: "flex gap-3 mt-6 px-10"
          })
        ],
        className: "bg-white lg:w-140.5 w-full py-6 mt-6 rounded-sm shadow-card"
      }),
      className: "w-full flex flex-col items-center px-4"
    }),
    className: "bg-gray-pale"
  });
}

const make = IdentityApiPage;

export {
  make,
}
/* Buhta_cabinet__AdminIdentitiesSubHeader Not a pure module */
